import { useEffect } from 'react';
/**
 * Handle clicks outside of an element.
 *
 * @param element Element, which clicks should be ignored.
 * @param onOutsideClick Function to fire on outside click.
 * @param options Additional options.
 */
export function useOutsideClick(element, onOutsideClick) {
  let {
    enabled = true,
    events = ['mousedown', 'touchstart'],
    excluded = []
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  useEffect(() => {
    if (!element || !enabled) return;
    const handleEvent = event => {
      if (excluded !== null && excluded !== void 0 && excluded.length && excluded.find(element => element === null || element === void 0 ? void 0 : element.contains(event.target))) return;
      if (!element.contains(event.target)) {
        onOutsideClick(event);
      }
    };
    for (let eventName of events) {
      document.addEventListener(eventName, handleEvent);
    }
    return () => {
      for (let eventName of events) {
        document.removeEventListener(eventName, handleEvent);
      }
    };
  }, [element, enabled, events, onOutsideClick]);
}
//# sourceMappingURL=useOutsideClick.js.map